import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SessionExpiredDialogService } from '../services/session-expired-dialog.service';

/** The one message the server sends when the same account signs in elsewhere. */
const KICKED_OUT =
    'You have been logged out because your account was accessed from another device.';

export const SessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {

    const sessionDialog = inject(SessionExpiredDialogService);
    const auth = inject(AuthService);
    if (req.url.includes('/api/profile/me')) {
        return next(req);
    }

    return next(req).pipe(
        catchError((error) => {
            if (error.status === 401 && error.error?.detail === KICKED_OUT) {
                // Drop the cached user as well as showing the dialog.
                //
                // The session is gone, so anything still holding that signal is
                // holding a lie -- and guestGuard is: it reads currentUser() and
                // sends whoever it finds there to the dashboard. That turned
                // "Return to Login" into a no-op. The dialog closed, the
                // navigation to /auth/get-started was redirected straight back
                // to /pro/dashboard, whose widgets fired more 401s, which
                // reopened the dialog. The only way out was a manual reload,
                // which worked for one reason: it threw this cache away.
                auth.currentUser.set(null);
                sessionDialog.open();
            }
            return throwError(() => error);
        })
    );
};
